
import * as Style from './styles'

export const AddressStandard = ({listItem, index, handleClick}) => {
    return(
        <Style.ContainerRadio>
            <Style.RadioButton  onClick={() => handleClick(index, listItem) } off={listItem.padrao === 'S' ? true : false}>
                <input
                    type={'radio'}
                    name={'radio'}
                />
            </Style.RadioButton>
        </Style.ContainerRadio>
    )
}